import React from 'react';

import classNames from 'classnames';

export interface IModalFooterProps {
    children: React.ReactNode;
    className?: string;
}

export const ModalFooter = (props: IModalFooterProps): JSX.Element => {
    const className: string = classNames(
        'modal__footer',
        props.className,
    );

    return <div className={className}>{props.children}</div>;
};
